import React from "react";
import {Control} from "react-hook-form/dist/types";
import {Controller, FieldPath} from "react-hook-form";
import ComboBox from "./ComboBox";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {CentroDiCostoRecord} from "@commons/mapping/CentroDiCostoRecord";
import {RegisterOptions} from "react-hook-form/dist/types/validator";

export function ComboBoxCdiCGruppi2<T extends FieldValues>(props: {
                                                               control: Control<T>, name: FieldPath<T>, defaultValue?: any, label?: string, displayValueFn?: any,
                                                               data: CentroDiCostoRecord[] | undefined, isLoading?: boolean, onChange?: (v: CentroDiCostoRecord | null) => void
                                                           }
) {
    return <Controller name={props.name}
                       control={props.control}
                       defaultValue={props.defaultValue}
                       rules={{required: true}}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<CentroDiCostoRecord> label={props.label} value={{id: value}} onChange={(value) => {
                                   onChange(value?.id);
                               }}
                                                              data={props.data} isLoading={props.isLoading}
                                                              searchablePropsName={["descrizione"]}
                                                              fieldState={fieldState}
                                                              isSameFn={(a, z) => (a && z) ? a.id === z.id : false}
                                                              keyValueFn={(v) => v.id!}
                                                              displayValueFn={props.displayValueFn ? props.displayValueFn : (v) => props.data && v ? `${v.descrizione} [#${v.id}]` : ''}
                               />
                           )
                       }}
    />
}

export function ComboBoxCdiCGruppi<T extends FieldValues>(props: {
                                                              control: Control<T>, name: FieldPath<T>, defaultValue: any, label: any, displayValueFn?: any,
                                                              data: CentroDiCostoRecord[] | undefined, isLoading?: boolean, onChange?: (v: CentroDiCostoRecord | null) => void,
                                                              rules?: Omit<RegisterOptions<T, FieldPath<T>>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>,
                                                          }
) {
    return <Controller name={props.name}
                       control={props.control}
                       defaultValue={props.defaultValue}
                       rules={props.rules}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<CentroDiCostoRecord> label={props.label} value={{id: value}} onChange={(value) => {
                                   onChange(value?.id);
                               }}
                                                              data={props.data} isLoading={props.isLoading}
                                                              searchablePropsName={["descrizione"]}
                                                              fieldState={fieldState}
                                                              isSameFn={(a, z) => (a && z) ? a.id === z.id : false}
                                                              keyValueFn={(v) => v.id!}
                                                              displayValueFn={props.displayValueFn ? props.displayValueFn : ((v) => props.data && v ? `${v.descrizione}` : '')}
                               />
                           )
                       }}
    />
}